var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81474 10.5687V3.66795H0.432611V10.5687H2.81474ZM1.62368 2.72593C2.45451 2.72593 2.97091 2.1968 2.97091 1.53338C2.95634 0.855924 2.45451 0.34082 1.63825 0.34082C0.821998 0.34082 0.291016 0.855924 0.291016 1.53338C0.291016 2.21083 0.807422 2.72593 1.60702 2.72593H1.62159H1.62368Z",
    fill: "#020101"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13281 10.5685H6.51494V6.71425C6.51494 6.50781 6.52952 6.30136 6.59407 6.15505C6.7669 5.74217 7.15837 5.31525 7.81637 5.31525C8.67844 5.31525 9.02409 5.94861 9.02409 6.8766V10.5685H11.4062V6.61203C11.4062 4.49148 10.2297 3.50537 8.66178 3.50537C7.37701 3.50537 6.81271 4.19685 6.49829 4.66786H6.51494V3.66772H4.13281C4.16405 4.31511 4.13281 10.5685 4.13281 10.5685Z",
    fill: "#020101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.1173,
    height: 10.2279,
    fill: "white",
    transform: "translate(0.291016 0.34082)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.171fe5f4b112c5704e0f09a932513d41.svg";
export { ForwardRef as ReactComponent };